export default __webpack_public_path__ + "static/media/Dhruvi.ef9cf73e.png";